@if (isNotReady) {
<mat-form-field class="form-field" appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ label }}</mat-label>
    <input type="text" matInput value="Chargement..." [disabled]="true">
    @if (hint) {
        <mat-hint>{{ hint }}</mat-hint>
    }
</mat-form-field>
} @else {
<mat-form-field class="form-field" appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ label }} <span *ngIf="saveIndicator && touched && searchCtrl.value?.length > 0" class="save-indicator"></span></mat-label>
    <input type="text" matInput [formControl]="searchCtrl" [matAutocomplete]="auto">
    @if (searchCtrl.value && searchCtrl.value.length > 0 && incompleteId | async) {
        <div class="suggestion">
            <div class="suggested-content">
                {{ searchCtrl.value }}<span class="end">{{ 'X'.repeat(missingLetters(searchCtrl.value)) }}</span>
            </div>
        </div>
    }

    @if (hint) {
        <mat-hint>{{ hint }}</mat-hint>
    }

    @if (selectedItemId && searchCtrl.enabled) {
        <button mat-icon-button matSuffix (click)="clear()">
            <mat-icon svgIcon="close"></mat-icon>
        </button>
    }

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
        (optionSelected)="onSelect($event.option.value)" (closed)="onClosed()">
        @if (incompleteId | async) {
            <mat-option [disabled]="true" class="incomplete-id">
                <mat-icon svgIcon="information-outline"></mat-icon>
                L'identifiant est incomplet
            </mat-option>
        } @else {
            @if(items?.length === 0) {
                @if (loading) {
                    <mat-option [disabled]="true">
                        Chargement en cours...
                    </mat-option>
                } @else {
                    <mat-option [disabled]="true">
                        Aucun élement
                    </mat-option>
                }
            } @else {
                <mat-option *ngFor="let item of items" [value]="item.id">
                    <div class="result">{{ item.name }} <span>{{ item.id }}</span></div>
                </mat-option>

                @if (!(items?.length === 1 && selectedItemId)) {
                    @if (totalSize === undefined) {
                        <div class="load-more show">
                            <div>
                                Charger plus d'éléments
                            </div>

                            <button (click)="loadNextPage()" mat-icon-button>
                                <mat-icon svgIcon="cloud-arrow-down-outline"></mat-icon>
                            </button>
                        </div>
                    } @else {
                        <div class="load-more" [class.show]="remainingItems(totalSize) > 0">
                            <div>
                                {{ remainingItems(totalSize) }} élements restants
                                <p>Affinez votre recherche</p>
                            </div>

                            <button (click)="loadNextPage()" mat-icon-button>
                                <mat-icon svgIcon="cloud-arrow-down-outline"></mat-icon>
                            </button>
                        </div>

                        <div class="load-more" [class.show]="remainingItems(totalSize) <= 0">
                            <div>
                                Tous les élements sont chargés
                                <p>{{ totalSize }} élements</p>
                            </div>
                        </div>
                    }
                }
            }
        }

    </mat-autocomplete>
</mat-form-field>
}
